import PropTypes from "prop-types";

// @mui material components
import Dialog from "@mui/material/Dialog";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";

/**
 * Modal used for every creation / edition form (wizards and add forms).
 * The form keeps rendering its own Card: the dialog paper is transparent and
 * lets the MD3 gradient header overflow above the card.
 * It can only be closed from the form (cancel / finish): clicking the backdrop
 * or pressing Escape would lose the user's input.
 */
export default function FormModal({ open = true, maxWidth = "lg", children }) {
	return (
		<Dialog
			open={open}
			maxWidth={maxWidth}
			fullWidth
			scroll="body"
			disableEscapeKeyDown
			PaperProps={{
				sx: {
					background: "transparent",
					boxShadow: "none",
					overflow: "visible",
					// Smaller outer margins on mobile
					// (&&& beats the more specific MUI paper width/margin rules)
					"@media (max-width: 599.95px)": {
						"&&&": {
							margin: "8px",
							width: "calc(100% - 16px)",
							maxWidth: "calc(100% - 16px)"
						}
					}
				}
			}}
		>
			{/* Room for the card headers that overflow above the card (mt={-3}) */}
			<MDBox pt={3}>{children}</MDBox>
		</Dialog>
	);
}

FormModal.propTypes = {
	open: PropTypes.bool,
	maxWidth: PropTypes.oneOf(["xs", "sm", "md", "lg", "xl"]),
	children: PropTypes.node.isRequired
};
